import React, { PropTypes } from 'react'
import ValmetFieldTemplate from "../components/ValmetFieldTemplate"
import {connect} from 'react-redux'

const ValmetFieldTemplateContainer = (props) => <ValmetFieldTemplate {...props} />

const mapStateToProps = state => ({
  conversionTable: state.forms.conversionTable
})

export default connect(mapStateToProps)(ValmetFieldTemplateContainer)


// WEBPACK FOOTER //
// ./src/containers/ValmetFieldTemplateContainer.js